import { OptionalLink } from '@atlassian/mpac-ui';
import React from 'react';
import { Section } from "../../../../Section";
const PaidViaPartnerPricing = props => {
  const {
    learnMoreUrl
  } = props;
  return /*#__PURE__*/React.createElement(Section, null, "This app is sold by a third-party vendor.", ' ', /*#__PURE__*/React.createElement(OptionalLink, {
    href: learnMoreUrl
  }, "Contact the vendor"), " to evaluate or purchase this app.");
};
export default PaidViaPartnerPricing;